<template lang="pug">
  dv-form(
    ref="questionOptionsForm"
    :schema="schema"
    v-slot="{ fields }"
  )
    v-row
      v-col(cols="12")
        h1.ui-h2.ui-neutral--text Варианты ответа
    v-row
      v-col(cols="12")
        dv-form-field(
          :field="fields.options"
        )
</template>

<script>
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';

export default {
  components: {
    DvForm,
    DvFormField,
  },
  props: {
    component: {
      type: [Object, String],
      required: true,
    },
    namespace: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    schema() {
      const { component } = this;

      return [
        {
          name: 'options',
          value: this.namespace,
          component,
        },
      ];
    },
  },
};
</script>
